var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLesson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#003D76",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 3h20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 3v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m7 21 5-5 5 5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLesson);
export default __webpack_public_path__ + "static/media/lesson.743b9b80d89f84c3bd8defa5bfbae544.svg";
export { ForwardRef as ReactComponent };